<template>
    <header-index />

    <!-- Hero Banner -->
    <!-- <section-gallery :gallery-name="'index-gallery-1'" /> -->
    <section-banner/>
    <!-- 产品包装展示区域 -->
    <section-packaging-category />

    <!-- 产品分类部分 - 带滑动功能 -->
    <section-production />

    <!-- 合作伙伴 -->
    <sectionCoperation />

    <!-- 服务特点部分 -->
    <section-service-trait />

    <!-- 关于我们部分 -->
    <section-about-us />

    <section-service-you-need />

    <section-get-inspired/>

    <!-- 将 sectionCTA 后面的页脚部分替换为新的页脚组件 -->
    <sectionCTA />

    <!-- 页脚 -->
    <footer-index />
</template>

<script setup lang="ts">
//import sectionGallery from './components/common/gallery.vue'
import sectionBanner from './components/index/sectionBanner.vue'
import sectionPackagingCategory from './components/index/sectionPackagingCategory.vue'
import sectionProduction from './components/index/sectionProduction.vue'
import sectionCoperation from './components/index/sectionCoperation.vue'
import sectionServiceTrait from './components/index/sectionServiceTrait.vue'
import sectionAboutUs from './components/index/sectionAboutUs.vue'
import sectionCTA from './components/common/sectionCTA.vue'
import sectionServiceYouNeed from './components/index/sectionServiceYouNeed.vue'
import sectionGetInspired from './components/index/sectionGetInspired.vue'
import headerIndex from './components/header/header-index.vue'
import footerIndex from './components/footer/footer-index.vue'

import cmsConfig from '~/cmsConfig';
// 服务端从缓存获取，客户端通过 API 获取，不序列化到 __NUXT_DATA__
const cmsInfo = await cmsUtils.getCmsInfo();

// 构建完整的网站 URL
const baseDomainUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain;
const canonicalUrl = baseDomainUrl ;

useHead({
    htmlAttrs: {
        lang: 'en'
    },
    title: cmsInfo.website.title,
    // 预加载关键 CSS，减少阻塞
    link: [
        {
            rel: 'preload',
            href: `/${cmsConfig.websiteName}/css/main.css`,
            as: 'style',
            fetchpriority: 'high',
        },
        { rel: 'canonical', href: canonicalUrl }
    ],
    meta: [
        { name: 'title', content: cmsInfo.website.title },
        { name: 'keywords', content: cmsInfo.website.keywords },
        { name: 'description', content: cmsInfo.website.description },
        // Open Graph
        { property: 'og:title', content: cmsInfo.website.title },
        { property: 'og:description', content: cmsInfo.website.description },
        { property: 'og:url', content: canonicalUrl },
        { property: 'og:image', content: "https://images.leaflypackaging.com/profile/upload/2025/11/24/1_20251124233036A077.webp" },
        { property: 'og:site_name', content: cmsInfo.website.title || 'The Leafly Packaging Company' },
        { property: 'og:type', content: 'website' },
        { property: 'og:locale', content: 'en_US' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: cmsInfo.website.title },
        { name: 'twitter:description', content: cmsInfo.website.description },
        // microsoft bing validate
        { name: 'msvalidate.01', content: 'C5E26BD973AAFC97EF937F3AE8E453AE' },
    ],
})
</script>

<style lang="scss" scoped>
    .gallery_item1_msg {
        position: absolute;
        top: 25%;
        left: 5%;
        width: 100%;
        z-index: 10;
    }

    .gallery-item1-header {
        font-size: 3.0rem;
        font-weight: 600;
        color: #fff;
        /* 从下往上滑入动画 */
        animation: slideDownFade 3.2s ease-out forwards;
        opacity: 0;
        transform: translateY(60px);
    }

    .gallery-item1-content {
        font-size: 1.5rem;
        color: #fff;
        border-radius: 5px;
        animation: slideDownFade 3.2s ease-out 0.3s forwards;
        line-height: 2rem;
        margin-top: 0px;
        margin-bottom: 32px;
        max-width: 720px;
        font-weight: 400;
    }

    .gallery-item1-button {
        font-size: 1.25rem;
        margin-top: 16px;
        display: block;
        color: #fff;
        width: 180px;
        text-align: center;
        padding-top: 4px;
        padding-bottom: 4px;
        border-radius: 8px;
        border: 2px solid white;
        animation: slideUpFade 3.2s ease-out 0.3s forwards;
    }

    .btn1 {
        background: rgba(124, 202, 86, 1);
    }

    .btn2 {
        background: rgba(0, 0, 0, 0);
        margin-left: 16px;
    }

    @keyframes slideUpFade {
        0% {
            opacity: 0;
            transform: translateY(160px);
        }

        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideDownFade {
        0% {
            opacity: 0;
            transform: translateY(-160px);
        }

        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideLeftFade {
        0% {
            opacity: 0;
            transform: translateX(1600px);
        }

        100% {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @media screen and (max-width: 768px) {
        .gallery-item1-header {
            font-size: 1.75rem;
        }

        .gallery-item1-content {
            font-size: 1.0rem;
            max-width: 80%;
        }
    }

    @media screen and (max-width: 1200px) and (min-width:768px) {
        .gallery-item1-header {
            font-size: 2.0rem;
        }

        .gallery-item1-content {
            font-size: 1.5rem;
            max-width: 50%;
        }
    }
</style>
